import styles from "./FavouriteStar.module.css";

interface FavouriteStarProps {
  active: boolean;
  onToggle: () => void;
  title: string;
}

export function FavouriteStar(props: FavouriteStarProps) {
  return (
    <button
      class={styles.star}
      classList={{ [styles.starOn]: props.active }}
      onClick={(e) => { e.stopPropagation(); props.onToggle(); }}
      title={props.title}
      aria-label={props.title}
      aria-pressed={props.active}
    >
      <i class={props.active ? "fa-solid fa-star" : "fa-regular fa-star"} aria-hidden="true" />
    </button>
  );
}

export default FavouriteStar;
